/*
 * @Author: wangpeipei1 wangpeipei1@wps.cn
 * @Date: 2023-02-10 10:53:44
 * @LastEditors: wangpeipei1 wangpeipei1@wps.cn
 * @LastEditTime: 2023-02-13 09:51:17
 * @FilePath: \edu-offical-website\src\common\login.js
 * @Description: 帐号登录切换
 */

import { isEnvMobile } from '@/common/utils';

class Login {
  constructor() {
    this.isPc = !isEnvMobile();
  }

  // 登录帐号
  login(callbackUrl) {
    const pageUrl = callbackUrl || window.location.href;
    const curUrl = encodeURIComponent(pageUrl);
    let loginUrl =
      'https://account.wps.cn/?logo=kos&from=kos' + '&cb=' + curUrl;
    window.location.href = loginUrl;
  }

  // 切换帐号
  switchAccount(callbackUrl) {
    const pageUrl = callbackUrl || window.location.href;
    const curUrl = encodeURIComponent(pageUrl);
    let loginUrl =
      'https://account.wps.cn/v1/changeaccount?logo=kos&from=kos' +
      '&cb=' +
      curUrl;
    window.location.href = loginUrl;
  }
}

export default new Login();
